module.exports = __webpack_public_path__ + "img/image11.1c0a5524.png";